<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{chartTitle| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">
    <!-- <app-bucket-performance-on-budget-widget *ngIf="showingChartId=='1'" [passedDataSource]="passedDataSource"
      [isInPopup]='true'></app-bucket-performance-on-budget-widget> -->
    <!-- <app-inspection-count-per-jobsite-widget *ngIf="showingChartId=='2'" [passedDataSource]="passedDataSource"
      [isInPopup]='true'></app-inspection-count-per-jobsite-widget> -->
    <!-- <app-cost-per-hour-widget *ngIf="showingChartId=='3'" [passedDataSource]="passedDataSource" [isInPopup]='true'>
    </app-cost-per-hour-widget>
    <app-cost-per-ton-widget *ngIf="showingChartId=='4'" [passedDataSource]="passedDataSource" [isInPopup]='true'>
    </app-cost-per-ton-widget>
    <app-cost-per-bcm-widget *ngIf="showingChartId=='5'" [passedDataSource]="passedDataSource" [isInPopup]='true'>
    </app-cost-per-bcm-widget> -->
  </div>